import { Card, Center, Flex, Group, Text } from "@mantine/core";
import {
  IconFile,
  IconFileTypeDoc,
  IconFileTypeDocx,
  IconFileTypeJpg,
  IconFileTypePdf,
  IconFileTypePng,
  IconFileTypeXls,
  IconFileTypeZip
} from "@tabler/icons-react";
import { AttachmentModel } from "../types/attachment.types";

import classes from './Attachment.module.css';

type FileExtension =
  'pdf' |
  'doc' |
  'docx' |
  'xls' |
  'xlsx' |
  'zip' |
  'png' |
  'jpg' |
  'jpeg';

const fileIcons = {
  pdf: IconFileTypePdf,
  doc: IconFileTypeDoc,
  docx: IconFileTypeDocx,
  xls: IconFileTypeXls,
  xlsx: IconFileTypeXls,
  zip: IconFileTypeZip,
  png: IconFileTypePng,
  jpg: IconFileTypeJpg,
  jpeg: IconFileTypeJpg,
};

export function fileIcon(attachment: AttachmentModel, size: AttachmentSize) {
  const isFullSize = size === 'full';
  let icon;
  let IconEl;

  if (typeof attachment.thumbnail_path === 'string') {
    return (
      <div
        className={classes.fileIconThumbnailContainer}
        style={{ width: isFullSize ? 'auto' : '37px' }}
      >
        <img
          src={attachment.thumbnail_path}
          alt={`Attached image: ${attachment.file_name}`}
          width="100%"
        />
      </div>
    );
  }

  const pathParts = attachment.path.split('.');
  const ext: FileExtension = pathParts[pathParts.length - 1].toLowerCase() as FileExtension;
  const IconComponent = ext in fileIcons ? fileIcons[ext] : IconFile;
  
  return (
    <Center h="100%">
      <IconComponent size={isFullSize ? 90 : 38} />
    </Center>
  );
}

export function fileSize(size: number) {
  const kb = 1024;
  const mb = 1024 * kb;
  let unit;
  let label;

  if (size >= mb) {
    unit = mb;
    label = "M";
  } else {
    unit = kb;
    label ="K";
  }

  return `${Math.round((size/unit) * 10) / 10}${label}`;
}

type AttachmentSize = 'full' | 'compact';

interface AttachmentProps {
  attachment: AttachmentModel;
}

export default function Attachment(
  { attachment }: AttachmentProps
) {
  return (
    <Card
      padding="sm"
      shadow="xs"
      withBorder={true}
      w="140px"
      component="a"
      href={attachment.path}
      target="_blank"
    >
      <Card.Section ta="center" h="140px" style={{ overflow: "hidden" }}>
        {fileIcon(attachment, 'full')}
      </Card.Section>
      <Text ta="center" className={classes.fileName} size="sm">
        {attachment.file_name}
      </Text>
      <Text ta="center" size="xs" c="gray.7">
        {fileSize(attachment.size)}
      </Text>
    </Card>
  )
}
